<template>
  <div class="c-table-style">
    <el-collapse>
      <el-collapse-item title="单元格">
        <el-form-item>
          <el-checkbox @change="onMergeCellsChange" v-model="selectItem.styleConfig.commongConfig.mergeCells">合并同类单元格</el-checkbox>
          <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">分页器</span>
            <el-switch v-model="selectItem.styleConfig.commongConfig.pagination">
            </el-switch>
          </div>
        </el-form-item>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import styleSubItem from '../base/styleSubItem.vue'

export default {
  name: 'cTableStyle',
  components: {
    styleSubItem
  },
  props: {
    selectItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      styleConfig: {
      }
    }
  },
  watch: {
    selectItem: {
      handler(newVal) {
        if (newVal && newVal.styleConfig) {
          this.styleConfig = { ...this.styleConfig, ...newVal.styleConfig }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    updateStyle() {
      // 更新 selectItem 的样式配置
      this.$set(this.selectItem, 'styleConfig', { ...this.styleConfig })
      // 触发样式更新事件
      this.$emit('styleUpdate', this.styleConfig)
    },
    onMergeCellsChange(val) {
      const queryList = this.selectItem.queryList
      this.$emit('table-page-change', queryList.current, queryList.pageSize)
    }
  }
}
</script>

<style scoped lang="less">
.c-table-style {
  // 表格样式配置组件样式
  
  :deep(.el-collapse-item__header) {
    direction: rtl;
    padding: 0 12px;
    display: block;
    text-align: left;
    background-color: var(--bi-jz-bg-color);
    color: var(--bi-jz-font-color);
    border-color: hsla(0, 0%, 85%, 0.15);
  }

  :deep(.el-collapse-item__header.is-active) {
    border-color: transparent;
  }

  :deep(.el-collapse) {
    border-top-color: transparent;
    border-bottom-color: transparent;
  }

  :deep(.el-collapse-item__content) {
    padding-bottom: 12px;
  }

  :deep(.el-collapse-item__wrap) {
    background-color: var(--bi-jz-bg-color);
    border-bottom-color: hsla(0, 0%, 85%, 0.15);
    padding: 0 12px;
  }

  :deep(.el-form-item__label) {
    color: var(--bi-jz-sub-color);
    font-size: 12px;
  }

  :deep(.el-radio-group) {
    display: flex;
    gap: 24px;
    
    .el-radio {
      color: var(--bi-jz-font-color);
      margin-right: 0;
      display: flex;
      align-items: center;
      
      .el-radio__label {
        color: var(--bi-jz-sub-color);
        font-size: 12px;
        padding-left: 8px;
      }
      
      .el-radio__input.is-checked .el-radio__inner {
        background-color: #2e74ff;
        border-color: #2e74ff;
      }
      
      .el-radio__inner {
        background-color: transparent;
        border-color: rgba(255, 255, 255, 0.3);
        width: 16px;
        height: 16px;
      }
      
      .el-radio__input.is-checked .el-radio__inner::after {
        width: 6px;
        height: 6px;
        background-color: #fff;
      }
    }
  }
}
</style>
